import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { fwUtil } from "../../../../script/util";
import { useAuth } from "../../../../../contexts/auth";
import { CommDash } from "../../../../script/components/dash-board/dash-body/dash-body";
import { DashItemClieCard } from "./Dash-item-clie";
import { DashSalePursCard } from "./Dash-sale-purs";
import { FwAppLoader } from "../../../../script/components/load-panel/load-panel";
import { combineSalePursData } from "./Dash-util";
import "./dash.scss";

export default function SalePursDash(props) {
    const {
        acce, gubu, cata, catb, code,
        title,
    } = props;

    // api
    const saleSearchApi = `${acce}/${gubu}/${cata}/${catb}/sale/search`;  // 매출 조회 api
    const pursSearchApi = `${acce}/${gubu}/${cata}/${catb}/purs/search`;  // 매입 조회 api
    const dateSearchApi = `${acce}/${gubu}/${cata}/${catb}/date/search`;  // 매월 조회 api
    // 시스템
    const [loading, setLoading] = useState(true);
    const [pageLoading, setPageLoading] = useState(true);
    // 권한
    const { authCheck } = useAuth();
    const [authList, setAuthList] = useState([]);
    // 대쉬보드
    const dashRef = useRef(null);
    const [dashData, setDashData] = useState([]);
    const [dateData, setDateData] = useState([]);
    const dashDataUpdate = useCallback((e) => setDashData(e), []);
    const dateDataUpdate = useCallback((e) => setDateData(e), []);
    // 검색 조건
    const [dateValue, setDateValue] = useState(fwUtil.date.getsText.range());
    const [duraYesn, setDuraYesn] = useState(false);
    const [clieName, setClieName] = useState("");
    const dateValueChange = useCallback((e) => { setDateValue([e.value[0], e.value[1]]) }, []);
    const duraYesnChange = useCallback((e) => { setDuraYesn(e.value) }, []);
    const clieNameChange = useCallback((e) => { setClieName(e) }, []);

    // 접근 권한 조회 및 권한 상태값 설정
    useEffect(() => {
        authCheck(setLoading, setAuthList, gubu, code);
    }, [authCheck, setLoading, setAuthList, gubu, code]);

    // 조회
    const handleSearch = useCallback(async () => {
        setPageLoading(true);
        const dashSendData = { start: dateValue[0], compl: dateValue[1], duraYesn: duraYesn, clieName: clieName };
        const dateSendData = { start: dateValue[0], compl: dateValue[1], duraYesn: duraYesn };
        const saleRes = await fwUtil.apis.search(saleSearchApi, dashSendData);
        const pursRes = await fwUtil.apis.search(pursSearchApi, dashSendData);
        const dateRes = await fwUtil.apis.search(dateSearchApi, dateSendData);
        const combData = combineSalePursData(saleRes, pursRes);
        dashDataUpdate(combData);
        dateDataUpdate(dateRes);
        setPageLoading(false);
    }, [dateValue, duraYesn, clieName, saleSearchApi, pursSearchApi, dateSearchApi, dateDataUpdate, dashDataUpdate]);

    useEffect(() => {
        handleSearch();
    }, [handleSearch]);

    // 추가 툴바 아이템
    const toolbarItems = useMemo(() => [
        { locate: 'before', type: 'text', caption: '고객명', value: clieName, valueChange: clieNameChange, search: handleSearch },
    ], [clieName, clieNameChange, handleSearch]);

    return (
        <div className="fw-dash-page fw-flex-box col sale-purs">
            <FwAppLoader loading={loading} />
            <CommDash
                title={title}
                dashRef={dashRef}                
                duraYesn={duraYesn}                
                dateValue={dateValue}
                duraYesnChange={duraYesnChange}                
                dateValueChange={dateValueChange}
                search={handleSearch}
                exp={{ fileName: "매출/매입 대쉬보드", disabled: authList.auth_dnlo === 0 }}
                toolbar={{ items: toolbarItems }}
            >
                <DashItemClieCard loading={pageLoading} data={dashData} />
                <DashSalePursCard loading={pageLoading} data={dateData} />
            </CommDash>
        </div>
    )
}